import './Column.scss';

export { default } from './Column';
